// extracted by mini-css-extract-plugin
module.exports = {"host":"vmo2-theme_host__bJ9oT"};